import React from 'react';

export function DataTable({ columns = [], rows = [], hover = true, empty, className = '', ...rest }) {
  if (!rows.length && empty) return empty;
  return (
    <div className="sp-table-scroll">
    <table className={['sp-table', hover && 'sp-table--hover', className].filter(Boolean).join(' ')} {...rest}>
      <thead>
        <tr>
          {columns.map(c => (
            <th key={c.key} className={c.numeric ? 'sp-table__num' : undefined} style={c.width ? { width: c.width } : undefined}>
              {c.header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={r.id != null ? r.id : i}>
            {columns.map(c => (
              <td key={c.key} className={c.numeric ? 'sp-table__num' : undefined}>
                {c.render ? c.render(r, i) : r[c.key]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  );
}
